/**
 * Keeps the first time of each run of times that format to the same label, so weekly data with a
 * month formatter gets one tick per month instead of "Jul, Aug, Aug, Sep".
 */
export function dedupeTicks(times: number[], format: (time: number) => string): number[] {
    return times.filter((time, i) => i === 0 || format(time) !== format(times[i - 1]));
}
